const queues = new Map<string, Promise<unknown>>();

/** Web Locks serialize whole read/project/write operations across tabs. CAS additionally protects storage. */
export async function withProfileLock<T>(key: string, action: () => Promise<T>): Promise<T> {
  if (globalThis.navigator?.locks) return globalThis.navigator.locks.request(key, action);
  if (typeof window !== "undefined") throw new Error("Deze browser ondersteunt geen veilige sessievergrendeling. Gebruik een recente browser.");
  const prior = queues.get(key) ?? Promise.resolve();
  const pending = prior.catch(() => undefined).then(action);
  queues.set(key, pending);
  try { return await pending; }
  finally { if (queues.get(key) === pending) queues.delete(key); }
}
